<p-card>
  <div class="text-center">
    <i class="fa-solid fa-ban text-red fa-3x"></i>
    <div class="mt-3" role="alert" aria-atomic="true">{{ message }}</div>
  </div>
</p-card>
